
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {}
})
export default class CalendarSwiper extends Vue {
  @Prop() currentKey: number
  @Prop({ default: [] }) list: unknown[]

  current: number = 0

  get isFirst() {
    return this.current === 0
  }

  get isLast() {
    return this.current === this.list.length - 1
  }

  get wrapperStyle() {
    return {
      transform: `translateX(-${this.current * 100}%)`
    }
  }

  handlePrev() {
    if (this.current === 0) return
    this.current--
  }

  handleNext() {
    if (this.current === this.list.length - 1) return
    this.current++
  }

  init() {
    if (typeof this.currentKey === 'number' && Number.isFinite(this.currentKey) && this.currentKey <= this.list.length - 1) {
      this.current = this.currentKey
    }
  }

  created(): void {
    this.init()
  }

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
